import { z } from 'zod';
import { SummarySchema } from './summary.schema.js';
export const MONITORING_SCHEDULE_TYPES = [
    'weekly',
    'monthly',
    'twice_monthly',
    'every_two_months',
    'custom'
];
/** Schedule types plus 'inactive' — used in filter UIs and query params. */ export const MONITORING_SCHEDULE_FILTER_TYPES = [
    ...MONITORING_SCHEDULE_TYPES,
    'inactive'
];
/** Schedule types plus the inactive sentinel — used in report/series data. */ export const MONITORING_SCHEDULE_DATA_TYPES = [
    ...MONITORING_SCHEDULE_TYPES,
    'inactive'
];
export const OngoingMonitoringChangeSchema = z.object({
    category: z.string(),
    reasoning: z.string(),
    severity: z.enum([
        'low',
        'medium',
        'high'
    ])
}).meta({
    id: 'OngoingMonitoringChange'
});
export const OngoingMonitoringSchema = z.object({
    changes: z.array(OngoingMonitoringChangeSchema).nullish(),
    summary: SummarySchema.nullish(),
    changesSnippet: z.string().nullish()
}).meta({
    id: 'OngoingMonitoring'
});

//# sourceMappingURL=ongoing-monitoring.schema.js.map